// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3IslU","title":"Header_title__2-Tu4","left":"Header_left__2nfqu","clinicName":"Header_clinicName__2YK9_"};